
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as env3hcmFXU3sNma7kfMe8Z4hldqgTKM_FWolswt_45Y4p5vAMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/env.vue?macro=true";
import { default as swapvAp2cozBvEqf13fTT9ucegBGQxX53hrnsUYDfVRWI0kMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/swap.vue?macro=true";
import { default as voteZDVRYDpcuezn6kBb9OsdqVYtawvU4tkU2YGEbUptClUMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/vote.vue?macro=true";
import { default as indexLvrl6M8FHgDN2yJqaSDueP0a7_fTCCSPJNaIEJi60gAMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/index.vue?macro=true";
import { default as gaugeVguDXRZnf1An_dRNxuJdrBJLXXh60xtMtEusSh_rG6wMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/manage/gauge.vue?macro=true";
import { default as indexaGV5Bw9TOugmAktgxTqzhBZ0YYROHN8tZW9f6u_45T41kMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/manage/index.vue?macro=true";
import { default as marketiAkXVUMiDAlkc8rTrKAA8XrsK0Xe3dwJuMuPK3IpeiwMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/manage/market.vue?macro=true";
import { default as projectsKvVD3WzWLGjHbDstAXevior4Ql4iy9usuepHBRJDyksMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/manage/projects.vue?macro=true";
import { default as launchpadkuZGG7lT8KfZaDuGZKR5n1TUhF6nUG5MlcGANAKkresMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/manage/launchpad.vue?macro=true";
import { default as managebRJzgD7DgnqcehLEp005JGNB1qHxhYAbFpWZvtSANAcMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/manage.vue?macro=true";
import { default as vaultsNweJTejtQbCCfPQBvTj2lcPZeFIl5AtD6bplqpoyf8IMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/vaults.vue?macro=true";
import { default as rewardsdjc74vgjsZihA2lbMj6GVBmAGPVjssAxYFsCHZJo0s0Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/rewards.vue?macro=true";
import { default as indexuuQUDQoZ_45n_45oKBpLoQIFl9tvlBtgYjuJPKMdj_JusgwMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/missions/index.vue?macro=true";
import { default as progressQisCj2ZD_45zaPP3E4_qtrAwJ_456g8y69NZdH82iBCM3akMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/missions/progress.vue?macro=true";
import { default as leaderboardaWSg7F975iNaxiHmhk6tD39pz7jmcBeSyAoPRCIh9GwMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/missions/leaderboard.vue?macro=true";
import { default as missions1XKGUktDt4J2b6gJqicfaRU29SZIkb1S0b6HV8_IsfcMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/missions.vue?macro=true";
import { default as indexj_cKAnMBJH6m0ikkIF_JvnEq_BlvSjHkWohXID2tNCgMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/settings/index.vue?macro=true";
import { default as stakingeWYpfxAD_45gjOm__45nA_45vM5OsHQBVDrtTgptLAjXP8VK0Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/settings/staking.vue?macro=true";
import { default as allocator22773mcSQ_zaJd29oJlOY4q2DHjWtupAM6EKZYlo_TcMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/settings/allocator.vue?macro=true";
import { default as cpmm_45allowanceGGc7Lqs8n8NMmfgX_K7OfZY_3zy43s9T_giEL2DJ254Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/settings/cpmm-allowance.vue?macro=true";
import { default as settings0sXabAe9gnKegcYVM_q5OkU3LjBp7Y_45CI_45nObZhYXsoMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/settings.vue?macro=true";
import { default as indexSkzU2CZIgomATidO89xvqYnLcthTL03ijQEpvkR4JboMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/portfolio/index.vue?macro=true";
import { default as indexku1rXYZofiYLbD_a_45mc78kgDXm1EHyzgl8MOkcv7O4oMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/portfolio/activities/index.vue?macro=true";
import { default as rewardsj5qN5_45e2wjhghserggEZKjAe0KFd5fMsvWLpAJ8riRsMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/portfolio/activities/rewards.vue?macro=true";
import { default as swap_45historymmGuB0bFH18hd641biIVrm1qu3hBKuNiKdbjLSXzOmAMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/portfolio/activities/swap-history.vue?macro=true";
import { default as activitiesoMOsNA5oKU4G9YqxHvPrfnDDr33EIY20h5jTP7uKqc4Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/portfolio/activities.vue?macro=true";
import { default as portfolio2AxFhzvMSShe_cwk87RXZUNC6Vo6srgh5d3ubAOwrhYMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/portfolio.vue?macro=true";
import { default as playgroundmmL9_BItodJf5aGDPs_45Quan2YjO6WmT3h_O5J3mZTVsMeta } from "/home/runner/_work/mito-ui/mito-ui/node_modules/.c12/github_InjectiveLabs_injective_B5Ll5JMqHu/pages/playground.vue?macro=true";
import { default as createOs_45AkLDBcuj10Ea_45zqWFRiztec4Y4PJPrac7FaqvrVcMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/cpmm/create.vue?macro=true";
import { default as maintenance3QGlFyAfiVlryf2VLmAxbwPkcgtCbHPT_tdzVQlPXQEMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/maintenance.vue?macro=true";
import { default as terms_45of_45usezsWqAL_IdzgZRbOSamiQtBnMSFr5W2GQHOitIVd8CD0Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/terms-of-use.vue?macro=true";
import { default as info_97HXUOaLkl7_45mJgXARF8klDbTDFmYeV_45JCGlN_eaO4Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/info.vue?macro=true";
import { default as indexAZMIoaQ8WZr43YGaMf06zWbcIS26iC_45AAwZ4Nj5k_KAMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/index.vue?macro=true";
import { default as configfCKU_45aYdq2gclkQj9JhAMqL06XsCMh9GTtvziAVq_1oMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/config.vue?macro=true";
import { default as rewardsgEMjK_c0CwO5ehu1MJeMex9HvfWf4pBMcWSIKlXOGUIMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/rewards.vue?macro=true";
import { default as liquiditywLLow3MMNmUr6loC_4539gAkMTXTTWocvS6DKiueqg2k0Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/liquidity.vue?macro=true";
import { default as indexScd3_nVoBK_k3O7VEpCO_457jMejsi1KHNpGEft2CeRz0Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/activities/index.vue?macro=true";
import { default as ordersFpBpszmok2fzcRcJgX7gPFdY2JbaDNd_GHJn7AvChDAMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/activities/orders.vue?macro=true";
import { default as tradesuuq5yRVLH1iy0Oq7OvLVbx1OKiItFfRj3tqYWe_UPn8Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/activities/trades.vue?macro=true";
import { default as activitiesErX7CoYsedFQCmvnDk3qYrLY3W3Dai22ZKxJ0mzKP44Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/activities.vue?macro=true";
import { default as _91vault_93Phd2LxPNL5sGY84Tlt9lTNPb7_45JkxFofyqXt6vq0NisMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault].vue?macro=true";
import { default as privacy_45policyMQ3JIc4uIBlK7Uf9Vd0dXTnk_45Hs7S_rLYiSXGMkjtaUMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/privacy-policy.vue?macro=true";
import { default as indexL4WFmhY9dIQcDCEihye1EP0Jrv75yr6MnsQhbO5Ot_45UMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/index.vue?macro=true";
import { default as resultk0M2t_45VoK_45bL3aNU_MonEEEDVbfP0xFF1vGEOjKVEnQMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/result.vue?macro=true";
import { default as whitelisthMITtX9Zypn9PNoNTrloShatrEw_BtRo75dHfMZL7I4Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/whitelist.vue?macro=true";
import { default as subscribersFfQZRDOD1x104HG2hd2sFLSRLY2TvGf9ur_45djmxQoa0Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/subscribers.vue?macro=true";
import { default as subscriptioniAzN_BPHCd0qwovp96XOq6BbcQ1oIqYwELjZS5NomN0Meta } from "/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/subscription.vue?macro=true";
import { default as _91ido_93oZ9vckulMP3_456JQwOXolT7P_451HjJdobEIuzC3IsfGnwMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido].vue?macro=true";
import { default as indexaECj12SudMj57l1uQaykMtUioDYE4TUmdVqFH5I7lfkMeta } from "/home/runner/_work/mito-ui/mito-ui/pages/launchpad/index.vue?macro=true";
export default [
  {
    name: "env",
    path: "/env",
    meta: env3hcmFXU3sNma7kfMe8Z4hldqgTKM_FWolswt_45Y4p5vAMeta || {},
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/env.vue")
  },
  {
    name: "swap",
    path: "/swap",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/swap.vue")
  },
  {
    name: "vote",
    path: "/vote",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vote.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexLvrl6M8FHgDN2yJqaSDueP0a7_fTCCSPJNaIEJi60gAMeta || {},
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/index.vue")
  },
  {
    name: managebRJzgD7DgnqcehLEp005JGNB1qHxhYAbFpWZvtSANAcMeta?.name,
    path: "/manage",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/manage.vue"),
    children: [
  {
    name: "manage-gauge",
    path: "gauge",
    meta: {"middleware":"is-owner"},
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/manage/gauge.vue")
  },
  {
    name: "manage",
    path: "",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/manage/index.vue")
  },
  {
    name: "manage-market",
    path: "market",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/manage/market.vue")
  },
  {
    name: "manage-projects",
    path: "projects",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/manage/projects.vue")
  },
  {
    name: "manage-launchpad",
    path: "launchpad",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/manage/launchpad.vue")
  }
]
  },
  {
    name: "vaults",
    path: "/vaults",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vaults.vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/rewards.vue")
  },
  {
    name: missions1XKGUktDt4J2b6gJqicfaRU29SZIkb1S0b6HV8_IsfcMeta?.name,
    path: "/missions",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/missions.vue"),
    children: [
  {
    name: "missions",
    path: "",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/missions/index.vue")
  },
  {
    name: "missions-progress",
    path: "progress",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/missions/progress.vue")
  },
  {
    name: "missions-leaderboard",
    path: "leaderboard",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/missions/leaderboard.vue")
  }
]
  },
  {
    name: settings0sXabAe9gnKegcYVM_q5OkU3LjBp7Y_45CI_45nObZhYXsoMeta?.name,
    path: "/settings",
    meta: {"middleware":"is-master-contract-owner"},
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/settings.vue"),
    children: [
  {
    name: "settings",
    path: "",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/settings/index.vue")
  },
  {
    name: "settings-staking",
    path: "staking",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/settings/staking.vue")
  },
  {
    name: "settings-allocator",
    path: "allocator",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/settings/allocator.vue")
  },
  {
    name: "settings-cpmm-allowance",
    path: "cpmm-allowance",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/settings/cpmm-allowance.vue")
  }
]
  },
  {
    name: portfolio2AxFhzvMSShe_cwk87RXZUNC6Vo6srgh5d3ubAOwrhYMeta?.name,
    path: "/portfolio",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/portfolio.vue"),
    children: [
  {
    name: "portfolio",
    path: "",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/portfolio/index.vue")
  },
  {
    name: activitiesoMOsNA5oKU4G9YqxHvPrfnDDr33EIY20h5jTP7uKqc4Meta?.name,
    path: "activities",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/portfolio/activities.vue"),
    children: [
  {
    name: "portfolio-activities",
    path: "",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/portfolio/activities/index.vue")
  },
  {
    name: "portfolio-activities-rewards",
    path: "rewards",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/portfolio/activities/rewards.vue")
  },
  {
    name: "portfolio-activities-swap-history",
    path: "swap-history",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/portfolio/activities/swap-history.vue")
  }
]
  }
]
  },
  {
    name: "playground",
    path: "/playground",
    meta: playgroundmmL9_BItodJf5aGDPs_45Quan2YjO6WmT3h_O5J3mZTVsMeta || {},
    component: () => import("/home/runner/_work/mito-ui/mito-ui/node_modules/.c12/github_InjectiveLabs_injective_B5Ll5JMqHu/pages/playground.vue")
  },
  {
    name: "cpmm-create",
    path: "/cpmm/create",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/cpmm/create.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenance3QGlFyAfiVlryf2VLmAxbwPkcgtCbHPT_tdzVQlPXQEMeta || {},
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/maintenance.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    meta: terms_45of_45usezsWqAL_IdzgZRbOSamiQtBnMSFr5W2GQHOitIVd8CD0Meta || {},
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/terms-of-use.vue")
  },
  {
    name: _91vault_93Phd2LxPNL5sGY84Tlt9lTNPb7_45JkxFofyqXt6vq0NisMeta?.name,
    path: "/vault/:vault()",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault].vue"),
    children: [
  {
    name: "vault-vault-info",
    path: "info",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/info.vue")
  },
  {
    name: "vault-vault",
    path: "",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/index.vue")
  },
  {
    name: "vault-vault-config",
    path: "config",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/config.vue")
  },
  {
    name: "vault-vault-rewards",
    path: "rewards",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/rewards.vue")
  },
  {
    name: "vault-vault-liquidity",
    path: "liquidity",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/liquidity.vue")
  },
  {
    name: activitiesErX7CoYsedFQCmvnDk3qYrLY3W3Dai22ZKxJ0mzKP44Meta?.name,
    path: "activities",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/activities.vue"),
    children: [
  {
    name: "vault-vault-activities",
    path: "",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/activities/index.vue")
  },
  {
    name: "vault-vault-activities-orders",
    path: "orders",
    meta: {"middleware":"is-dev-mode"},
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/activities/orders.vue")
  },
  {
    name: "vault-vault-activities-trades",
    path: "trades",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vault/[vault]/activities/trades.vue")
  }
]
  }
]
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyMQ3JIc4uIBlK7Uf9Vd0dXTnk_45Hs7S_rLYiSXGMkjtaUMeta || {},
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/privacy-policy.vue")
  },
  {
    name: _91ido_93oZ9vckulMP3_456JQwOXolT7P_451HjJdobEIuzC3IsfGnwMeta?.name,
    path: "/launchpad/:ido()",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido].vue"),
    children: [
  {
    name: "launchpad-ido",
    path: "",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/index.vue")
  },
  {
    name: "launchpad-ido-result",
    path: "result",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/result.vue")
  },
  {
    name: "launchpad-ido-whitelist",
    path: "whitelist",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/whitelist.vue")
  },
  {
    name: "launchpad-ido-subscribers",
    path: "subscribers",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/subscribers.vue")
  },
  {
    name: "launchpad-ido-subscription",
    path: "subscription",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/launchpad/[ido]/subscription.vue")
  }
]
  },
  {
    name: "launchpad",
    path: "/launchpad",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/launchpad/index.vue")
  },
  {
    name: "vaults",
    path: "/vaults",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vaults.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/home/runner/_work/mito-ui/mito-ui/pages/vaults.vue")
  }
]